import styled from "styled-components";

export const ActionButtons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
`;
export const CustomColumn = styled.div`
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
